import { GridSortModel } from "@mui/x-data-grid";
import { useState } from "react";

import { DEFAULT_PAGE_SIZE } from "api/constants";

export function useDataGridController() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const onPageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  const onSortModelChange = (sortModel: GridSortModel) => {
    setSortModel(sortModel);
  };

  return {
    page,
    pageSize,
    sortModel,
    onPageChange,
    onPageSizeChange,
    onSortModelChange,
  };
}
